import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'
import { accessQuery } from '@/api/queries'
import { rememberCompany } from '@/app/session'
import { errorText } from '@/domain/errors'
import { t } from '@/i18n'
import { InlineBanner } from '@/ui/inline-banner'
import { Page } from '@/ui/page'
import { LoadingBlock } from '@/ui/spinner'

export const Route = createFileRoute('/_app/c/$orgId')({
  component: CompanyLayout,
})

/// Everything under /c/{orgId} needs the caller's `/access` answer — it says
/// which sections and which buttons exist. Children render only once it is
/// in, so they read it with `useSuspenseQuery` and never wait.
function CompanyLayout() {
  const { orgId } = Route.useParams()
  const access = useQuery(accessQuery(orgId))

  useEffect(() => {
    if (access.data) rememberCompany(orgId)
  }, [access.data, orgId])

  if (access.isPending) return <LoadingBlock label={t.app.loading} />
  if (access.isError) {
    return (
      <Page>
        <InlineBanner
          kind="error"
          message={errorText(access.error)}
          action={{ label: t.app.retry, onClick: () => void access.refetch() }}
        />
      </Page>
    )
  }
  return <Outlet />
}
